import * as DatepickerActions from '../actions/datepickers';
import * as FindUserActions from '../actions/findUser';

import ReduxAction from '../interfaces/ReduxAction';

export function personalInfoMountTab (): ReduxAction {
  return (dispatch): void => {
    dispatch(DatepickerActions.fetchDatepickersHideAction());
    dispatch(FindUserActions.fetchActiveTabAction(0));
  };
}
